import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccountPage } from './account.page';

const routes: Routes = [
  {
    path: '',
    component: AccountPage,
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'change-password',
    loadChildren: () => import('./change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./contact-us/contact-us.module').then( m => m.ContactUsPageModule)
  },
  {
    path: 'mydogs',
    loadChildren: () => import('./mydogs/mydogs.module').then( m => m.MydogsPageModule)
  },
  {
    path: 'myposts',
    loadChildren: () => import('./myposts/myposts.module').then( m => m.MypostsPageModule)
  },
  {
    path: 'mycases',
    loadChildren: () => import('./mycases/mycases.module').then( m => m.MycasesPageModule)
  },
  {
    path: 'deactivate',
    loadChildren: () => import('./deactivate/deactivate.module').then( m => m.DeactivatePageModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountPageRoutingModule {}
